import { useNavigate, useLocation } from 'react-router-dom';
import { ButtonWithIcon } from 'ui-kit/Buttons';
import { IconCircleArrowLeft } from '@tabler/icons-react';
import { useNavigationState } from 'app-level/navigation/navigationState';

export const RemittanceBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigationState = useNavigationState();

  const handleBackClick = () => {
    const backRouteRules = [
      {
        pattern: /^\/portfolio\/remittance\/dealId\/[^/]+\/cashflow\/?$/,
        buildParentPath: (path: string) => path.replace(/\/cashflow\/?$/, ''),
      },
    ];

    const matchedRule = backRouteRules.find((rule) => rule.pattern.test(location.pathname));
    if (matchedRule) {
      const parentPath = matchedRule.buildParentPath(location.pathname);
      if (parentPath.includes('/portfolio/remittance/')) {
        const dealIdMatch = parentPath.match(/\/portfolio\/remittance\/(.+)/);
        if (dealIdMatch) {
          navigationState.current.portfolio.remittance_path = dealIdMatch[1];
        }
      }
      navigate(parentPath, { replace: true });
      return;
    }

    // Find the nearest param from [accountId, dealId] and remove everything from it
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const params = ['uploadId', 'accountId', 'dealId'];

    // Find the last occurrence of any param
    let paramIndex = -1;
    for (let i = pathSegments.length - 1; i >= 0; i--) {
      if (params.includes(pathSegments[i])) {
        paramIndex = i;
        break;
      }
    }

    // Remove everything from the param onwards
    const parentSegments = paramIndex >= 0 ? pathSegments.slice(0, paramIndex) : pathSegments;
    const parentPath = '/' + parentSegments.join('/');

    // Update navigation state based on parent path
    if (parentPath === '/portfolio/remittance') {
      // Going back to base remittance, clear the path
      navigationState.current.portfolio.remittance_path = undefined;
    } else if (parentPath.includes('/portfolio/remittance/')) {
      // Preserve the remaining path
      const dealIdMatch = parentPath.match(/\/portfolio\/remittance\/(.+)/);
      if (dealIdMatch) {
        navigationState.current.portfolio.remittance_path = dealIdMatch[1];
      }
    }

    navigate(parentPath, { replace: true });
  };

  return (
    <ButtonWithIcon
      onClick={handleBackClick}
      iconPosition="left"
      icon={<IconCircleArrowLeft size="18px" />}
      label="Back"
      size="medium"
      type="link"
      className="border-none !px-0"
    />
  );
};
